import React, { Component } from "react";

import axios from "axios";
import { Spinner } from "../components/Spinner";
import EmailAccountsDataTable from "../components/EmailAccountsDataTable";

import { Alert } from "reactstrap";
import { LoggedUserContext } from "../LoggedUserContext";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { acquireToken } from "../adalConfig";

const MySwal = withReactContent(Swal);

export default class EmailAccountContainer extends Component {
  state = {
    items: [],
    loading: false,
  };

  async componentDidMount() {
    this.setState({ loading: true });
    await acquireToken().then(async (token) => {
      const url = `${process.env.REACT_APP_API_URL}/EmailAccountAPI/GetEmailAccounts/true`;
      await axios
        .get(url, { headers: { Authorization: `Bearer ${token}` } })
        .then((res) => {
          if (res.data.code === 0) {
            this.setState({ items: res.data.items, loading: false });
          } else {
            MySwal.fire({
              icon: "error",
              title:
                "An error has occurred while retrieving the email accounts",
              //text: res.data.description,
              confirmButtonColor: "#FFE600",
              confirmButtonText: "<div style='color: black'>OK</div>",
            }).then(() => {
              window.location.reload();
            });
          }
        })
        .catch((error) => {
          if (error.toString().includes("status code 403")) {
            window.location.href = "/NoAuth";
          } else {
            MySwal.fire({
              icon: "error",
              title:
                "An error has occurred while retrieving the email accounts",
              //text: error,
              confirmButtonColor: "#FFE600",
              confirmButtonText: "<div style='color: black'>OK</div>",
            }).then(() => {
              window.location.reload();
            });
          }
        });
    });

    for (let i = 0; i < this.state.items.length; ++i) {
      await this.GetUserName(i);
    }
  }

  render() {
    const { loading, items } = this.state;
    return loading ? (
      <div>
        <Alert color="primary" fade={true}>
          This operation might take a moment.
        </Alert>
        <Spinner />
      </div>
    ) : (
      <div>
        <EmailAccountsDataTable data={items} loading={loading} />
      </div>
    );
  }

  async GetUserName(index) {
    await acquireToken().then(async (token) => {
      const id = this.state.items[index].emailAccountUserModifiedId;
      const url = `${process.env.REACT_APP_API_URL}/UserApi/GetUsersPerId${id !== this.context.userId ? '?ui=' + this.encryptStringXORtoHex(id, "CampaignToolEncKey") : ''}`;
      await axios
        .get(url, { headers: { Authorization: `Bearer ${token}` } })
        .then((res) => {
          if (res.data.code === 0) {
            let stateItems = this.state.items;
            stateItems[index][
              "UserModifiedFullName"
            ] = `${res.data.items[0].userFirstName} ${res.data.items[0].userLastName}`;
            this.setState({ items: stateItems });
          } else {
            MySwal.fire({
              icon: "error",
              title: "An error has occurred while retrieving the user data",
              //text: res.data.description,
              confirmButtonColor: "#FFE600",
              confirmButtonText: "<div style='color: black'>OK</div>",
            }).then(() => {
              window.location.reload();
            });
          }
        })
        .catch((error) => {
          if (error.toString().includes("status code 403")) {
            window.location.href = "/NoAuth";
          } else {
            MySwal.fire({
              icon: "error",
              title: "An error has occurred while retrieving the user data",
              //text: error,
              confirmButtonColor: "#FFE600",
              confirmButtonText: "<div style='color: black'>OK</div>",
            }).then(() => {
              window.location.reload();
            });
          }
        });
    });
  }

  encryptStringXORtoHex(input, key) {
    let result = "";
    while (key.length < input.length) {
      key += key;
    }
    for (var i = 0; i < input.length; i++) {
      var value1 = input[i].charCodeAt(0);
      var value2 = key[i].charCodeAt(0);

      var xorValue = value1 ^ value2;

      var xorValueAsHexString = xorValue.toString("16");

      if (xorValueAsHexString.length < 2) {
        xorValueAsHexString = "0" + xorValueAsHexString;
      }

      result += xorValueAsHexString;
    }
    return result;
  }
}

EmailAccountContainer.contextType = LoggedUserContext;
